import { render, staticRenderFns } from "./Groups.vue?vue&type=template&id=319d960a"
import script from "./Groups.vue?vue&type=script&lang=js"
export * from "./Groups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('319d960a')) {
      api.createRecord('319d960a', component.options)
    } else {
      api.reload('319d960a', component.options)
    }
    module.hot.accept("./Groups.vue?vue&type=template&id=319d960a", function () {
      api.rerender('319d960a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/account/views/groups/Groups.vue"
export default component.exports